module.exports = __webpack_public_path__ + "static/media/im5.8f1707e4.png";